export enum InvitationChannel {
    ScbConnect = 'scbconnect',
    Email = 'email'
}